export default __webpack_public_path__ + "media/changemakers.975f2d074a028a90c9ba9f635ce9d4c6.svg";